import React from "react";
import { withTranslation } from "react-i18next";
import classNames from "classnames";
import "./index.scss";

import SearchControl from "../SearchControl/SearchControl";

import { SHOW_DROPDOWN_NAME } from "../../../utils/enums";
import {
  equalsAddress,
  getAddress,
  locationIsEmpty,
  isSameLocations
} from "../../../services/order";

const FindAddress = ({
  t,
  isHideSearch,
  showDropDownName,
  orderAddressLocation,
  searchAddress,
  suggestedAddresses,
  previousAddresses,
  getSuggested,
  onChangeSearch,
  onSelect,
  onShowDropdown
}) => {
  const isAddressEquals = (a1, a2) => {
    return (
      a1 && a2 &&
      !locationIsEmpty(a1.location) &&
      equalsAddress(a1.address, a2.address) &&
      isSameLocations(a1.location, a2.location)
    );
  };

  return (
    <div className={classNames("findAddress")}>
      {!isHideSearch && (
        <div className={classNames("header")}>
          <SearchControl
            placeholder={t("orders.SEARCH_PLACEHOLDER")}
            value={searchAddress}
            onChange={value => onChangeSearch(searchAddress, value)}
            debounce={500}
          />
          <div
            className={classNames("buttonAddress")}
            onClick={() => onShowDropdown(SHOW_DROPDOWN_NAME.suggest)}
          >
            <div
              className={classNames("suggestIcon", {
                active: showDropDownName === SHOW_DROPDOWN_NAME.suggest
              })}
            />
          </div>
          <div
            className={classNames("buttonAddress")}
            onClick={() => onShowDropdown(SHOW_DROPDOWN_NAME.history)}
          >
            <div
              className={classNames("historyIcon", {
                active: showDropDownName === SHOW_DROPDOWN_NAME.history
              })}
            />
          </div>
        </div>
      )}
      {(showDropDownName === SHOW_DROPDOWN_NAME.suggest ||
        showDropDownName === SHOW_DROPDOWN_NAME.history) && (
        <div className={classNames("info")}>
          {getSuggested && <div className={classNames("preloader")} />}
          {showDropDownName === SHOW_DROPDOWN_NAME.suggest && (
            <h4>{t("assistance.GEO_LOCATION_LABEL")}</h4>
          )}
          {showDropDownName === SHOW_DROPDOWN_NAME.history && (
            <h4>{t("assistance.PREVIOUS_ADDRESSES_LABEL")}</h4>
          )}
          <div className={classNames("items")}>
            {showDropDownName === SHOW_DROPDOWN_NAME.suggest && (
              <ul>
                {(!suggestedAddresses || !suggestedAddresses.length) && (
                  <li className={classNames("empty")}>
                    {t("assistance.NO_SUGGESTED_ADDRESSES")}
                  </li>
                )}
                {suggestedAddresses.map((variant, index) => (
                  <li
                    key={`variant=${index}`}
                    className={classNames({
                      selected: isAddressEquals(orderAddressLocation, variant)
                    })}
                    onClick={() => onSelect(variant)}
                  >
                    {getAddress(variant.address)}
                  </li>
                ))}
              </ul>
            )}
            {showDropDownName === SHOW_DROPDOWN_NAME.history && (
              <ul>
                {(!previousAddresses || !previousAddresses.length) && (
                  <li className={classNames("empty")}>
                    {t("assistance.NO_PREVIOUS_ADDRESSES")}
                  </li>
                )}
                {previousAddresses.map((variant, index) => (
                  <li
                    key={`variant=${index}`}
                    className={classNames({
                      selected: isAddressEquals(orderAddressLocation, variant)
                    })}
                    onClick={() => onSelect(variant)}
                  >
                    variant
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default withTranslation()(FindAddress);
